import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import React, {useEffect, useState} from 'react';
import { StyledCompanyContainer, StyledFlexStart, StyledSubHeader } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import BiztantuFooterButton from '../../../Components/FotterButton';
import { useSelector } from 'react-redux';
import RolePermissionComponenet from '../../../Components/RolePermissionComponent';
import { DataGrid, GridRowModes, GridToolbarContainer, GridToolbar, GridActionsCellItem } from '@mui/x-data-grid';
import { createRequestData, getRequestData, requestDeleteApiCall } from '../../../Utility/apiHelper';
import { requestgetcurrenctuser } from '../../../Store/User/action';
import { useDispatch } from 'react-redux';
import { handleValidateCodevalue } from '../../../Utility/constant';
import deleteIcon from '../../../Assets/images/trashIcon.png';
import { requestHideLoader, requestShowLoader } from '../../../Store/Global/action';
    const CreateEditRole = ({selectionData, handleSavePermission,
        handleUpdateRoles,
         handleCustomBackbutton,
         isCreate,
         isEdit,
         enqueueSnackbar,
         roleId
    }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const permissionSet = useSelector(state => state?.permission?.allPermissionTypes);
    const [selectedaddedValue, setectedaddedValue] = useState(null);
    const [roleDetail, setRoleDetail] = useState(null);
    const [requiredValue, setRequiredvalue] = useState({
        name: false,
        description: false,
        permission: false,
    });
    const dispatch = useDispatch();
    const [dataGridData, setdataGridData] = useState([]);

    useEffect(() => {
        if(selectionData?.isEdit && selectionData?.isEditRoleId) {
            handleRequestGetRoles();
            handleRequestGetRolePermission();
        }
    },[selectionData?.isEdit])


    const handleRequestGetRoles = async() => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_BASE_URL}roles/${selectionData?.isEditRoleId}`;
        const responseData  = await getRequestData(url); 
        setRoleDetail(responseData?.data);
        dispatch(requestHideLoader())
    }
    
    const handleRequestGetRolePermission = async() => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_BASE_URL}rolepermissions`;
        const responseData  = await getRequestData(url); 
        const filteredPermission = responseData?.data?.map(item => {
            if(item?.role?.id == selectionData?.isEditRoleId) {
                return {name:item?.permission?.name,
                description: item?.permission?.description,
            id: item?.id,
            permissionId : item?.permission?.id};
            }}).filter(Boolean);

        setdataGridData(filteredPermission);
        dispatch(requestHideLoader())
    }

    const handleRequestAddRolePermission = async() => {
        dispatch(requestShowLoader())
        
        const url = `${process.env.REACT_APP_BASE_URL}rolepermissions`;
        const rolepermission = {};
        rolepermission["permission"] = {id: selectedaddedValue?.id};
        rolepermission["role"] = {id: selectionData?.isEditRoleId};
        
        const responseData  = await createRequestData(rolepermission, url); 

        if(responseData?.status == 200) {
            await handleRequestGetRolePermission();
            const token = localStorage.getItem('accessToken');
            await dispatch(requestgetcurrenctuser(token));
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ADDED_SUCCESSFULLY"), {variant: 'success'})
        }
        
        dispatch(requestHideLoader())
    }


    const handleRequestDeleteRolePermission = async(id) => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_BASE_URL}rolepermissions/${id}`;
        const responseData = await requestDeleteApiCall(url);

        if(responseData?.status) {
            await handleRequestGetRolePermission();
            const token = localStorage.getItem('accessToken');
            await dispatch(requestgetcurrenctuser(token));
          
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"), {variant: 'success'})
        }
       
        dispatch(requestHideLoader())
    }

    const handleDelete = (id) => async() => {

        if(selectionData?.isCreate) {
            const deletedDatagrid = dataGridData?.filter(item => item?.id != id );
            setdataGridData(deletedDatagrid);
        }

        if(selectionData?.isEdit) {
            handleRequestDeleteRolePermission(id);
        }

    }
    
    const columns = [
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_PERM_NAME'),
          flex: 1,
          editable: false ,
        },
        
        {
          field: 'actions',
          type: 'actions',
          headerName:handleValidateCodevalue(internationalise,'COMMON_ACTION'),
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
           
            return [
              <GridActionsCellItem
                icon={<img src={deleteIcon} />}
                label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                className="textPrimary"
                onClick={handleDelete(id)}
                color="inherit"
              />
            ];
          },
        },
    ];

    const handleChangeCompanyDetails = (event) => {
        setRoleDetail({
            ...roleDetail,
            [event.target.name]: event.target.value
        })
    }

    const handleSave = (value) => {
        if(roleDetail?.name) {
            const reqBody = {
                "description": roleDetail?.description,
                "name": roleDetail?.name,
                "id" : selectionData?.isEditRoleId,

            }

            if(dataGridData?.length > 0) {
                reqBody['ispermission'] = dataGridData;
            }
            if(isEdit){
            handleUpdateRoles(value,reqBody)
            }
            else{
            handleSavePermission(reqBody)
            }
        } else {
            setRequiredvalue({
                name: true,
                description: true,
                permission: true
            })
        }
    }

    const handleSelectMultiPermission = (event, permissionType, reason) => {
    setectedaddedValue(permissionType);
        
    }

    const handleSelectedAddValue = async() => {
        const isExist = dataGridData?.filter(item => item?.permissionId == selectedaddedValue?.id);
           
        if(selectionData?.isCreate) {
            // const isExist = dataGridData?.filter(item => item?.id == selectedaddedValue?.id);
            if(isExist.length > 0) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ALREADY_ADDED"), {variant: 'warning'})
            } else {
                if(dataGridData?.length == 0) {
                    setdataGridData([...dataGridData,  selectedaddedValue]);
                }
                
            }
        } 

        if(selectionData?.isEdit) {
            if(isExist.length > 0) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_ALREADY_ADDED"), {variant: 'warning'})
            } else {
                handleRequestAddRolePermission();
            }
           
        }

        setectedaddedValue(null);
       
    }

    return (
        <React.Fragment>
            <Box sx={{marginBottom: 0, padding: "20px", marginTop: "20px",
                height: "calc(100vh - 131px)",
                overflow: "auto",
                '& .MuiTextField-root': { m: 1, marginTop: 1 },
                }}>
                <Typography variant='h6'>
                    {/* {selectionData?.isEdit ? handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_TITLE_EDIT'):handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_TITLE_CREATE')} */}
                </Typography>
                <StyledSubHeader>
                    {handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_DETAILS')}
                 </StyledSubHeader>
                 
                <StyledFlexStart>
                    <TextFiledWithLabel
                        required={true}
                        name= "name" 
                        error={roleDetail?.name ? false : requiredValue?.name}
                        value= {roleDetail?.name}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_NAME')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
        
                    <TextFiledWithLabel
                        required={true}
                        sx={{width: "60ch"}}
                        name= "description"
                        // error={roleDetail?.description ? false : requiredValue?.description}
                        value= {roleDetail?.description}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_DESC')}
                        handleOnChange={handleChangeCompanyDetails}
                    />
                    
                 </StyledFlexStart>
                 <StyledSubHeader>
                    {handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_ASSIGN')}
                 </StyledSubHeader>
                    <RolePermissionComponenet
                        selectedaddedValue={selectedaddedValue}
                        dropdownlist={permissionSet?.filter(item => !dataGridData?.some(dataItem => item?.name === dataItem?.name))}
                        handleSelectedValue = {handleSelectMultiPermission}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_PERM')}
                        isEdit = {selectionData?.isEdit}
                        isCreate = {selectionData?.isCreate}
                        placeholder={handleValidateCodevalue(internationalise,'CONF_ROLE_EDIT_SELECT_PERM')}
                        columns={columns}
                        dataGridData = {dataGridData}
                        handleSelectedAddValue = {handleSelectedAddValue}
                    />
                </Box>
            
                <BiztantuFooterButton 
                    isEdituser={isEdit}
                    headerLabel={"CONF_ROLE_EDIT_TITLE_EDIT"}
                    isiconRequired={false}
                    handleActionButton2 = {()=>handleSave(true)}
                    actionlabel2 = {handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}
                    actionlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    isBackbtnreq={true}
                    handleCustomBackbutton={handleCustomBackbutton}
                    redirecturl=""
                    handleActionButton={()=>handleSave(false)}
                    backButtonLabel= {handleValidateCodevalue(internationalise,"COMMON_BACK")}
                />
        </React.Fragment>
    )
}

export default CreateEditRole;